import { Injectable, signal, WritableSignal } from '@angular/core';

/**
 * Estado de sesión reactivo compartido.
 * Mantiene el userId del usuario autenticado como signal para que
 * los computed (ej. PermissionService.myPermissions) reaccionen a
 * cambios de usuario (login/logout) sin depender de localStorage.
 */
@Injectable({
    providedIn: 'root'
})
export class SessionService {
    private _userId: WritableSignal<string | null> = signal<string | null>(this.readUserId());

    public readonly userId = this._userId.asReadonly();

    private readUserId(): string | null {
        try {
            return localStorage.getItem('userId');
        } catch {
            return null;
        }
    }

    setCurrentUser(userId: string | null): void {
        this._userId.set(userId);
        try {
            if (userId) {
                localStorage.setItem('userId', userId);
            } else {
                localStorage.removeItem('userId');
            }
        } catch {
            // storage no disponible (modo privado); la signal sigue funcionando
        }
    }
}
